import { domain } from 'modules/data';

export const isFieldVisible = (documentFieldState: domain.DocumentFieldState | undefined) =>
    documentFieldState !== domain.DocumentFieldState.Hidden;
